import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, slDateTime } from "@/lib/api";
import { inputCls } from "@/pages/Login";

const ST = { neplacano: "Neplačano", caka_nakazilo: "Čaka na nakazilo", placano: "Plačano", vrnjeno: "Vrnjeno", preklicano: "Preklicano" };

function BankSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/bank-settings").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const save = async () => {
    try { const r = await api.put("/admin/bank-settings", { ...s, qr_designs_price: Number(s.qr_designs_price) }); setS(r.data); toast.success("Podatki za plačilo so shranjeni."); } catch (e) { toast.error(errMsg(e)); }
  };
  const F = (k, l, extra = {}) => <label className="block text-sm text-[#6C6560]">{l}<input className={`${inputCls} mt-1`} value={s[k] ?? ""} onChange={set(k)} data-testid={`bank-settings-${k}`} {...extra} /></label>;
  return (
    <div className="card-lux p-6 space-y-3" data-testid="bank-settings">
      <h3 className="font-display text-2xl">Podatki za plačilo (TRR)</h3>
      <div className="grid sm:grid-cols-2 gap-3">
        {F("recipient", "Prejemnik")}{F("iban", "IBAN", { placeholder: "SI56 ..." })}{F("bank", "Banka")}{F("bic", "BIC / SWIFT")}
        <label className="block text-sm text-[#6C6560]">Model reference
          <select className={`${inputCls} mt-1`} value={s.reference_model} onChange={set("reference_model")} data-testid="bank-settings-reference_model"><option value="SI12">SI12 (s kontrolno številko, modul 11)</option><option value="SI00">SI00 (brez kontrole)</option></select></label>
        {F("reference_prefix", "Predpona reference (samo številke, neobvezno)")}{F("purpose_template", "Namen plačila ({order} = številka naročila)")}{F("qr_designs_price", "Cena prenosa QR dizajnov (€)", { type: "number" })}
      </div>
      <p className="text-xs text-[#6C6560]">Referenca: model + leto + zaporedna številka naročila (+ kontrolna številka pri SI12). Spremembe veljajo za nova naročila.</p>
      <button onClick={save} className="btn-dark px-6 h-11 text-sm" data-testid="bank-settings-save">Shrani</button>
    </div>
  );
}

export default function PaymentsAdmin() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("caka_nakazilo");
  const load = () => api.get("/admin/payments", { params: filter ? { status: filter } : {} }).then((r) => setOrders(r.data));
  useEffect(() => { load(); }, [filter]);
  const act = async (o, path, body, msg) => {
    try { await api.post(`/admin/orders/${o.id}/${path}`, body); toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6" data-testid="payments-admin">
      <div className="flex gap-2 flex-wrap">
        {[["caka_nakazilo", "Čakajo na nakazilo"], ["neplacano", "Neplačana"], ["placano", "Plačana"], ["vrnjeno", "Vrnjena"], ["preklicano", "Preklicana"], ["", "Vsa"]].map(([k, l]) => (
          <button key={k || "all"} onClick={() => setFilter(k)} className={`px-4 py-2 rounded-full text-sm ${filter === k ? "bg-[#231F20] text-white" : "bg-[#F3ECE1]"}`} data-testid={`payments-filter-${k || "all"}`}>{l}</button>
        ))}
      </div>
      <div className="card-lux overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F3ECE1] text-left"><tr>{["Stranka", "Poroka", "Naročilo", "Referenca", "Znesek", "Način", "Status", "Datum", ""].map((h) => <th key={h} className="p-3">{h}</th>)}</tr></thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan={9} className="p-4 text-[#6C6560]">Ni naročil.</td></tr>}
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-[#EADBCE] align-top" data-testid={`payment-row-${o.number}`}>
                <td className="p-3">{o.customer_email}</td>
                <td className="p-3">{o.wedding_title}</td>
                <td className="p-3"><b>{o.number}</b><span className="block text-xs text-[#6C6560]">{o.label}</span></td>
                <td className="p-3 whitespace-nowrap">{o.reference}</td>
                <td className="p-3 whitespace-nowrap">{o.amount} €</td>
                <td className="p-3">{o.method === "bank" ? "Bančno nakazilo" : "—"}</td>
                <td className="p-3">{ST[o.status]}{o.confirmed_by && <span className="block text-xs text-[#6C6560]">{o.confirmed_by} · {slDateTime(o.confirmed_at)}</span>}</td>
                <td className="p-3 whitespace-nowrap text-[#6C6560]">{slDateTime(o.created_at)}</td>
                <td className="p-3 space-y-1">
                  {["neplacano", "caka_nakazilo"].includes(o.status) && <button onClick={() => window.confirm(`Potrdi prejeto nakazilo ${o.amount} € (${o.reference})?`) && act(o, "confirm", {}, "Nakazilo potrjeno, funkcije odklenjene.")} className="btn-dark px-3 py-1.5 text-xs whitespace-nowrap" data-testid="payment-confirm-button">Potrdi prejeto nakazilo</button>}
                  {["neplacano", "caka_nakazilo"].includes(o.status) && <button onClick={() => window.confirm("Prekličem naročilo?") && act(o, "status", { status: "preklicano" }, "Naročilo preklicano.")} className="block text-xs underline" data-testid="payment-cancel-button">Prekliči</button>}
                  {o.status === "placano" && <button onClick={() => window.confirm("Zabeležim vračilo plačila?") && act(o, "status", { status: "vrnjeno" }, "Vračilo zabeleženo.")} className="text-xs underline" data-testid="payment-refund-button">Vračilo plačila</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <BankSettings />
    </div>
  );
}
